/* Studio Services mega menu maps (TCL-69).
   The two Google map iframes carry their address in data-src so they cost
   nothing while the page loads. Once the page has finished loading and the
   browser is idle, they are loaded one after the other in the background, so
   they are already drawn when the menu opens.
     - Desktop menu only (min-width 981px, same breakpoint as section-header.css).
     - Skipped for shoppers on Data Saver; their maps load when the menu opens.
     - Opening the menu before the background load starts it right away. */
(function () {
  'use strict';

  var maps = Array.prototype.slice.call(document.querySelectorAll('iframe.megamenu__map[data-src]'));
  if (!maps.length) return;

  var desktop = window.matchMedia('(min-width: 981px)');
  var IDLE_DELAY = 1500;
  var NEXT_MAP_TIMEOUT = 5000;
  var scheduled = false;

  function start(map) {
    var src = map.getAttribute('data-src');
    if (!src) return false;
    map.removeAttribute('data-src');
    map.src = src;
    // Gives the hidden menu a size, so the map can draw before it is opened.
    var menu = map.closest('.megamenu');
    if (menu) menu.classList.add('megamenu--maps-warm');
    return true;
  }

  function loadNow() {
    maps.forEach(start);
  }

  function loadInTurn(index) {
    var map = maps[index];
    if (!map) return;
    var moved = false;
    function next() {
      if (moved) return;
      moved = true;
      loadInTurn(index + 1);
    }
    if (!start(map)) return next();
    map.addEventListener('load', next, { once: true });
    setTimeout(next, NEXT_MAP_TIMEOUT);
  }

  function whenIdle(fn) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: 4000 });
    } else {
      setTimeout(fn, 0);
    }
  }

  function schedule() {
    if (scheduled || !desktop.matches) return;
    var connection = navigator.connection;
    if (connection && connection.saveData) return;
    scheduled = true;
    setTimeout(function () {
      whenIdle(function () { loadInTurn(0); });
    }, IDLE_DELAY);
  }

  maps.forEach(function (map) {
    var item = map.closest('.navigation__menuitem');
    if (!item) return;
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
      item.addEventListener(type, loadNow, { once: true, passive: true });
    });
  });

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }

  if (desktop.addEventListener) {
    desktop.addEventListener('change', function () {
      if (document.readyState === 'complete') schedule();
    });
  }
})();
